import React, { useState } from "react";

import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import TimelineOutlinedIcon from "@material-ui/icons/TimelineOutlined";
import BrushOutlinedIcon from "@material-ui/icons/BrushOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";
import ExtensionOutlinedIcon from "@material-ui/icons/ExtensionOutlined";
import EventOutlinedIcon from "@material-ui/icons/EventOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";
import ViewAgendaOutlinedIcon from "@material-ui/icons/ViewAgendaOutlined";
import LibraryBooksOutlinedIcon from "@material-ui/icons/LibraryBooksOutlined";
import NotificationsNoneOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import ViewCarouselOutlinedIcon from "@material-ui/icons/ViewCarouselOutlined";
import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";

import NavigationCollapse from "./navigation-collapse";
import { useClient } from "../../../shared/contex/client/client-context";
import RoutesFormularios from "../../../routes/classics/formularios";
import RoutesUsuariosAcademia from "../../../routes/formacion/usuarios";

// Componente interno para encabezados de sección (agrupan varios collapses)
const SectionHeader = ({ label }) => (
  <div
    className="admin-muted-text px-2 pt-3 pb-1"
    style={{
      fontSize: "11px",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "#9aa0b4",
      borderTop: "1px solid #eef0f5",
      marginTop: "8px",
    }}
  >
    {label}
  </div>
);

const iconStyle = { marginRight: "15px" };

//En este componente eso donde estan las categorias y sus elementos correpondienes de la navegacion
//Cada categoria es un collapes el cual contiene botones donde cada boton corresponde a una pagina
const NavigationElements = () => {
  const { getClient } = useClient();
  const client = getClient();
  const access = client?.access;

  //En este estado guardamos todas las categorias existentes
  const [currentCategorie, setCurrentCategorie] = useState({
    Dashboard: false,
    // Gestión de clientes
    Clientes_VerDatos: false,
    Clientes_VerEstadisticas: false,
    Clientes_Adicionar: false,
    Clientes_Editar: false,
    Clientes_Eliminar: false,
    // Libros
    Libros_VerDatos: false,
    Libros_Recomendaciones: false,
    Libros_Adicionar: false,
    Libros_Editar: false,
    Libros_Eliminar: false,
    // Actividades
    Actividades_VerDatos: false,
    Actividades_Adicionar: false,
    Actividades_Editar: false,
    Actividades_Eliminar: false,
    // Eventos
    Eventos_Eventos: false,
    Eventos_Formularios: false,
    // Blog
    Blog_ManejoBlog: false,
    // Gestión de plataforma
    Plataforma_Banners: false,
    Plataforma_Filas: false,
    Plataforma_Recursos: false,
    Plataforma_Notibuzon: false,
    Plataforma_Notibanner: false,
    Plataforma_Usuarios: false,
    // Plan lector (sin cambios)
    PlanLector_VerDatos: false,
    PlanLector_VerEstadisticas: false,
    PlanLector_AdicionarElementos: false,
    PlanLector_EditarElementos: false,
    PlanLector_BorrarElementos: false,
    // Formación (sin cambios)
    Formacion_VerDatos: false,
    Formacion_AdicionarElementos: false,
    Formacion_EditarElementos: false,
    Formacion_BorrarElementos: false,
    // Nuevas regalías (sin cambios)
    NuevasRegalias_VerDatos: false,
    NuevasRegalias_AdicionarElementos: false,
  });

  function isDefined(arr1) {
    for (var i = 0; i < arr1.length; i++) {
      if (typeof arr1[i] !== "undefined") {
        return true;
      }
    }
    return false;
  }

  // Gates para decidir si mostrar cada collapse / sección
  const ver = {
    clientes: {
      ver_datos: isDefined([
        access?.ver_clientes,
        access?.ver_idp_saml,
        access?.ver_codigos_regalo,
      ]),
      ver_estadisticas: isDefined([
        access?.ver_lectura_libros,
        access?.ver_acceso_clientes,
        access?.ver_solicitudes_demo,
        access?.ver_acceso_institutos,
        access.ver_acceso_personal,
        access?.ver_estadisticas_globales,
      ]),
      adicionar: isDefined([
        access?.crear_cliente_instituto,
        access?.crear_cliente_individual,
        access?.crear_cliente_demo,
        access?.agregar_cliente_SAML,
        access?.ver_idp_saml,
        access?.crear_codigo,
      ]),
      editar: isDefined([
        access?.editar_cliente_individual,
        access?.editar_cliente_instituto,
        access?.editar_cliente_demo,
        access?.editar_cliente_SAML,
      ]),
      eliminar: isDefined([
        access?.eliminar_cliente_individual,
        access?.eliminar_cliente_instituto,
        access?.eliminar_SAML,
        access?.eliminar_cliente_demo,
      ]),
    },
    libros: {
      ver_datos: isDefined([access?.ver_libros]),
      recomendaciones: isDefined([access?.ver_lectura_libros, access?.ver_libros]),
      adicionar: isDefined([
        access?.crear_libro_contenido,
        access?.agregar_libro_paquete,
        access?.ver_libros,
        access?.autorizar_paquete_cliente,
        access?.agregar_libro_coleccion,
        access?.habilitar_paquete_cliente,
      ]),
      editar: isDefined([
        client?.access?.editar_libro_contenido,
        client?.access?.editar_libro_metadatos,
        access?.editar_coleccion_arte,
        access?.editar_arte_editorial,
        access?.CRUD_usuario_dios,
        access?.CRUD_usuario_editorial,
        access?.CRUD_usuario_vendedor,
      ]),
      eliminar: isDefined([
        access?.eliminar_libro_contenido,
        access?.eliminar_paquete_libros,
        access?.eliminar_coleccion,
      ]),
    },
    actividades: {
      ver_datos: isDefined([access?.ver_actividades]),
      adicionar: isDefined([access?.crear_actividad]),
      editar: isDefined([access?.editar_actividad]),
      eliminar: isDefined([access?.eliminar_actividad]),
    },
    eventos: {
      eventos: isDefined([
        access?.ver_codigos_regalo,
        access?.crear_cliente_instituto,
        access?.eliminar_cliente_instituto,
      ]),
      formularios: isDefined([access?.ver_codigos_regalo]),
    },
    blog: {
      manejo_blog: isDefined([
        access?.crear_entrada_blog,
        access?.editar_entrada_blog,
        access?.eliminar_entrada_blog,
      ]),
    },
    plataforma: {
      banners: isDefined([access?.editar_banners]),
      filas: isDefined([access?.filas_home, access?.crear_cliente_instituto]),
      recursos: isDefined([
        access?.ver_codigos_regalo,
        access?.crear_cliente_instituto,
        access?.eliminar_cliente_instituto,
      ]),
      notibuzon: isDefined([
        access?.ver_codigos_regalo,
        access?.crear_cliente_instituto,
        access?.eliminar_cliente_instituto,
      ]),
      notibanner: isDefined([
        access?.ver_codigos_regalo,
        access?.crear_cliente_instituto,
        access?.eliminar_cliente_instituto,
      ]),
      usuarios: isDefined([
        client?.access?.CRUD_usuario_dios,
        client?.access?.CRUD_usuario_editorial,
        client?.access?.CRUD_usuario_vendedor,
      ]),
    },
    plan_lector: {
      ver_datos: isDefined([
        client?.access?.ver_institutos_PL,
        client?.access?.ver_sedes,
        client?.access?.ver_cursos,
        client?.access?.ver_profesores,
        client?.access?.ver_estudiantes,
        client?.access?.reporte_lecturas,
        client?.access?.reporte_acceso_estudiantes,
      ]),
      ver_estadisticas: isDefined([
        client?.access?.reporte_acceso_estudiantes,
        client?.access?.reporte_lecturas,
      ]),
      adicionar_elementos: isDefined([
        client?.access?.agregar_instituto_PL,
        client?.access?.agregar_sede,
        client?.access?.agregar_curso,
        client?.access?.agregar_estudiante,
        client?.access?.agregar_profesor,
        client?.access?.habilitar_paquete_PL,
        client?.access?.autorizar_paquete_PL,
        client?.access?.escoger_libros_PL,
      ]),
      editar_elementos: isDefined([
        client?.access?.editar_instituto_PL,
        client?.access?.editar_estudiante,
        client?.access?.editar_sede,
        client?.access?.editar_curso,
        client?.access?.editar_profesor,
      ]),
      borrar_elementos: isDefined([
        client?.access?.eliminar_estudiante,
        client?.access?.eliminar_profesor,
        client?.access?.eliminar_curso,
        client?.access?.eliminar_instituto_PL,
        client?.access?.eliminar_sede,
      ]),
    },
    formacion: {
      ver_datos: isDefined([access?.ver_datos_academia]),
      adicionar_elementos: isDefined([
        access?.asisgnar_curso_academia,
        access?.crear_usuario_academia,
      ]),
      borrar_elementos: isDefined([""]),
    },
    regalias: {
      ver_datos: isDefined([access?.ver_regalias]),
      adicionar_elementos: isDefined([access?.crear_regalias]),
    },
  };

  // Booleans agregados a nivel de sección para mostrar / ocultar headers
  ver.clientes.value =
    ver.clientes.ver_datos ||
    ver.clientes.ver_estadisticas ||
    ver.clientes.adicionar ||
    ver.clientes.editar ||
    ver.clientes.eliminar;
  ver.libros.value =
    ver.libros.ver_datos ||
    ver.libros.recomendaciones ||
    ver.libros.adicionar ||
    ver.libros.editar ||
    ver.libros.eliminar;
  ver.actividades.value =
    ver.actividades.ver_datos ||
    ver.actividades.adicionar ||
    ver.actividades.editar ||
    ver.actividades.eliminar;
  ver.eventos.value = ver.eventos.eventos || ver.eventos.formularios;
  ver.blog.value = ver.blog.manejo_blog;
  ver.plataforma.value =
    ver.plataforma.banners ||
    ver.plataforma.filas ||
    ver.plataforma.recursos ||
    ver.plataforma.notibuzon ||
    ver.plataforma.notibanner ||
    ver.plataforma.usuarios;
  ver.plan_lector.value =
    ver.plan_lector.ver_datos ||
    ver.plan_lector.ver_estadisticas ||
    ver.plan_lector.adicionar_elementos ||
    ver.plan_lector.editar_elementos ||
    ver.plan_lector.borrar_elementos;
  ver.formacion.value =
    ver.formacion.ver_datos ||
    ver.formacion.adicionar_elementos ||
    ver.formacion.borrar_elementos;
  ver.regalias.value =
    ver.regalias.ver_datos || ver.regalias.adicionar_elementos;

  //Funcion para seleccionar una categoria
  const changeCategorie = (categorieID) => {
    const temp = { ...currentCategorie };
    if (temp[categorieID] === true) {
      temp[categorieID] = false;
      setCurrentCategorie(temp);
    } else {
      Object.keys(temp).map((key) => {
        temp[key] = false;
        return null;
      });
      temp[categorieID] = true;
      setCurrentCategorie(temp);
    }
  };

  const toCategorieItems = (routes) =>
    routes.map((route) => ({
      ...route,
      url: route.path,
      hide: access[route.access] ? false : true,
    }));

  /*
    Cada elemento (Item) debe tener su nombre y la url de la pagina a la que corresponde
    Esta url debe ser unica y la pagina tiene que estar en el componente admin-dashboard.jsx dentro del switch de react-router-dom
    de la carpeta main dentro de componentes
  */
  return (
    <>
      {/* DASHBOARD */}
      <NavigationCollapse
        categorieID={"Dashboard"}
        categorieLabel={"Dashboard"}
        currentCategorie={currentCategorie.Dashboard}
        categorieItems={[{ name: "Home", url: "/" }]}
        changeCategorie={changeCategorie}
      >
        <HomeOutlinedIcon style={iconStyle} />
      </NavigationCollapse>

      {/* =================== GESTIÓN DE CLIENTES =================== */}
      {ver.clientes.value && <SectionHeader label="Gestión de clientes" />}

      {ver.clientes.ver_datos && (
        <NavigationCollapse
          categorieID={"Clientes_VerDatos"}
          categorieLabel={"Ver datos"}
          currentCategorie={currentCategorie.Clientes_VerDatos}
          categorieItems={[
            {
              name: "Lista de super institutos",
              url: "/consultas/lista-super-institutos",
              hide: access?.ver_regalias ? false : true,
            },
            {
              name: "Lista de institutos",
              url: "/consultas/lista-institutos",
              hide: access?.ver_regalias ? false : true,
            },
            {
              name: "Lista de sedes",
              url: "/consultas/lista-sedes",
              hide: access?.ver_regalias ? false : true,
            },
            {
              name: "Lista de clientes",
              url: "/consultas/lista-clientes",
              hide: access?.ver_clientes ? false : true,
            },
            {
              name: "Lista de cuentas personales",
              url: "/consultas/lista-cuentas-personales",
              hide: access?.ver_regalias ? false : true,
            },
            {
              name: "Lista de IdPs SAML",
              url: "/consultas/lista-idps-saml",
              hide: access?.ver_idp_saml ? false : true,
            },
            {
              name: "Códigos de regalo",
              url: "/consultas/lista-codigos-regalo",
              hide: access?.ver_codigos_regalo ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <VisibilityOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.clientes.ver_estadisticas && (
        <NavigationCollapse
          categorieID={"Clientes_VerEstadisticas"}
          categorieLabel={"Ver estadísticas"}
          currentCategorie={currentCategorie.Clientes_VerEstadisticas}
          categorieItems={[
            {
              name: "Reporte de lecturas de libros",
              url: "/consultas/reporte-lecturas",
              hide: access?.ver_lectura_libros ? false : true,
            },
            {
              name: "Reporte de libros más leídos",
              url: "/consultas/reporte-lecturas-libros-mas-leidos",
              hide: access?.ver_lectura_libros ? false : true,
            },
            {
              name: "Reporte de accesos de clientes",
              url: "/consultas/reporte-acceso-clientes",
              hide: access?.ver_acceso_clientes ? false : true,
            },
            {
              name: "Reporte de solicitudes demo",
              url: "/consultas/reporte-solicitudes-demo",
              hide: access?.ver_solicitudes_demo ? false : true,
            },
            {
              name: "Estadísticas por instituto",
              url: "/consultas/estadisticas-acceso-instituto",
              hide: access?.ver_acceso_institutos ? false : true,
            },
            {
              name: "Estadísticas personales",
              url: "/consultas/estadisticas-acceso-personales",
              hide: access.ver_acceso_personal ? false : true,
            },
            {
              name: "Estadísticas globales de lectura y acceso",
              url: "/consultas/estadisticas-globales-lectura-acceso",
              hide: access?.ver_estadisticas_globales ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <TimelineOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.clientes.adicionar && (
        <NavigationCollapse
          categorieID={"Clientes_Adicionar"}
          categorieLabel={"Adicionar elementos"}
          currentCategorie={currentCategorie.Clientes_Adicionar}
          categorieItems={[
            {
              name: "Agregar un nuevo Super Instituto",
              url: "/registrar-y-editar/crear-super-instituto",
              hide: access?.crear_cliente_instituto ? false : true,
            },
            {
              name: "Agregar un nuevo Instituto",
              url: "/registrar-y-editar/crear-instituto",
              hide: access?.crear_cliente_instituto ? false : true,
            },
            {
              name: "Crear una sede",
              url: "/registrar-y-editar/crear-sede",
              hide: access?.crear_cliente_instituto ? false : true,
            },
            {
              name: "Agregar un nuevo cliente Instituto",
              url: "/registrar-y-editar/agregar-cliente-institucional",
              hide: access?.crear_cliente_instituto ? false : true,
            },
            {
              name: "Agregar un nuevo cliente Individual",
              url: "/registrar-y-editar/agregar-cliente-individual",
              hide:
                access?.crear_cliente_individual || access?.crear_cliente_demo
                  ? false
                  : true,
            },
            {
              name: "Agregar un nuevo Perfil Individual",
              url: "/registrar-y-editar/agregar-perfil-individual",
              hide:
                access?.crear_cliente_individual
                  ? false
                  : true,
            },
            {
              name: "Agregar un nuevo IdP SAML",
              url: "/registrar-y-editar/agregar-nuevo-cliente-saml",
              hide: access?.agregar_cliente_SAML ? false : true,
            },
            {
              name: "Agregar / Eliminar conexión OAuth",
              url: "/consultas/agregar-conexion-oauth",
              hide: access?.agregar_cliente_SAML ? false : true,
            },
            {
              name: "Asignar un nuevo código",
              url: "/registrar-y-editar/asignar-codigo",
              hide: access?.crear_codigo ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <AddCircleOutlineOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.clientes.editar && (
        <NavigationCollapse
          categorieID={"Clientes_Editar"}
          categorieLabel={"Editar elementos"}
          currentCategorie={currentCategorie.Clientes_Editar}
          categorieItems={[
            {
              name: "Editar Super Instituto",
              url: "/registrar-y-editar/editar-super-instituto",
              hide: access?.crear_cliente_instituto ? false : true,
            },
            {
              name: "Editar Instituto",
              url: "/registrar-y-editar/editar-instituto",
              hide: access?.crear_cliente_instituto ? false : true,
            },
            {
              name: "Editar sede",
              url: "/registrar-y-editar/editar-sede",
              hide: access?.crear_cliente_instituto ? false : true,
            },
            {
              name: "Editar un cliente Instituto existente",
              url: "/registrar-y-editar/editar-cliente-institucional-existente",
              hide: access?.editar_cliente_instituto ? false : true,
            },
            {
              name: "Editar un cliente Individual existente",
              url: "/registrar-y-editar/editar-cliente-individual-existente",
              hide:
                access?.editar_cliente_individual ||
                  client?.access?.editar_cliente_demo
                  ? false
                  : true,
            },
            {
              name: "Editar un cliente Personal existente",
              url: "/registrar-y-editar/editar-perfil-individual-existente",
              hide:
                access?.editar_cliente_individual 
                  ? false
                  : true,
            },
            {
              name: "Editar un IdP SAML",
              url: "/registrar-y-editar/editar-cliente-saml",
              hide: access?.editar_cliente_SAML ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <EditOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.clientes.eliminar && (
        <NavigationCollapse
          categorieID={"Clientes_Eliminar"}
          categorieLabel={"Eliminar elementos"}
          currentCategorie={currentCategorie.Clientes_Eliminar}
          categorieItems={[
            {
              name: "Eliminar Super Instituto",
              url: "/registrar-y-editar/eliminar-super-instituto",
              hide: access?.eliminar_cliente_instituto ? false : true,
            },
            {
              name: "Eliminar Instituto",
              url: "/registrar-y-editar/eliminar-instituto",
              hide: access?.eliminar_cliente_instituto ? false : true,
            },
            {
              name: "Eliminar sede",
              url: "/registrar-y-editar/eliminar-sede",
              hide: access?.eliminar_cliente_instituto ? false : true,
            },
            {
              name: "Eliminar un cliente Instituto existente",
              url: "/registrar-y-editar/eliminar-cliente-institucional",
              hide: access?.eliminar_cliente_instituto ? false : true,
            },
            {
              name: "Eliminar un cliente Individual existente",
              url: "/registrar-y-editar/eliminar-cliente-individual",
              hide: access?.eliminar_cliente_individual || access?.eliminar_cliente_demo ? false : true,
            },
            {
              name: "Eliminar un cliente Personal existente",
              url: "/registrar-y-editar/eliminar-perfil-individual",
              hide: access?.eliminar_cliente_individual ? false : true,
            },
            {
              name: "Eliminar un IdP SAML",
              url: "/registrar-y-editar/eliminar-saml",
              hide: access?.eliminar_SAML ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <DeleteOutlineIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {/* =================== LIBROS =================== */}
      {ver.libros.value && <SectionHeader label="Libros" />}

      {ver.libros.ver_datos && (
        <NavigationCollapse
          categorieID={"Libros_VerDatos"}
          categorieLabel={"Ver datos"}
          currentCategorie={currentCategorie.Libros_VerDatos}
          categorieItems={[
            {
              name: "Lista de libros",
              url: "/consultas/lista-libros",
              hide: access?.ver_libros ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <MenuBookOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.libros.recomendaciones && (
        <NavigationCollapse
          categorieID={"Libros_Recomendaciones"}
          categorieLabel={"Recomendaciones"}
          currentCategorie={currentCategorie.Libros_Recomendaciones}
          categorieItems={[
            {
              name: "Recomendación de paquetes de renovación",
              url: "/consultas/recomendacion-paquetes",
              hide:
                access?.ver_regalias ? false : true,
            },
            {
              name: "Catálogo de renovación (Super Instituto)",
              url: "/consultas/catalogo-renovacion",
              hide:
                access?.ver_regalias ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <LibraryBooksOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.libros.adicionar && (
        <NavigationCollapse
          categorieID={"Libros_Adicionar"}
          categorieLabel={"Adicionar elementos"}
          currentCategorie={currentCategorie.Libros_Adicionar}
          categorieItems={[
            {
              name: "Agregar un nuevo libro",
              url: "/registrar-y-editar/agregar-nuevo-libro",
              hide: access?.crear_libro_contenido ? false : true,
            },
            {
              name: "Agregar o eliminar libros de un paquete",
              url: "/registrar-y-editar/agregar-eliminar-libros-paquete",
              hide: access?.agregar_libro_paquete ? false : true,
            },
            {
              name: "Paquetes relacionados a un libro",
              url: "/registrar-y-editar/paquetes-libro",
              hide: access?.agregar_libro_paquete ? false : true,
            },
            {
              name: "Agregar o eliminar un paquete a un cliente",
              url: "/registrar-y-editar/agregar-eliminar-paquete-cliente",
              hide: access?.autorizar_paquete_cliente ? false : true,
            },
            {
              name: "Agregar o eliminar libros de una colección",
              url: "/registrar-y-editar/agregar-eliminar-libros-coleccion",
              hide: access?.agregar_libro_coleccion ? false : true,
            },
            {
              name: "Habilitar un paquete a un cliente",
              url: "/registrar-y-editar/habilitar-paquete-cliente",
              hide: access?.habilitar_paquete_cliente ? false : true,
            },
            {
              name: "Autorizar paquete personalizado para cliente",
              url: "/registrar-y-editar/autorizar-paquete-cliente",
              hide: access?.autorizar_paquete_cliente ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <AddCircleOutlineOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.libros.editar && (
        <NavigationCollapse
          categorieID={"Libros_Editar"}
          categorieLabel={"Editar elementos"}
          currentCategorie={currentCategorie.Libros_Editar}
          categorieItems={[
            {
              name: "Editar un libro",
              url: "/registrar-y-editar/editar-libro",
              hide:
                client?.access?.editar_libro_contenido &&
                  client?.access?.editar_libro_metadatos
                  ? false
                  : true,
            },
            {
              name: "Editar el arte de una colección",
              url: "/registrar-y-editar/editar-arte-coleccion",
              hide: access?.editar_coleccion_arte ? false : true,
            },
            {
              name: "Editar el arte de una editorial",
              url: "/registrar-y-editar/editar-arte-editorial",
              hide: access?.editar_arte_editorial ? false : true,
            },
            {
              name: "Agregar / editar tags",
              url: "/registrar-y-editar/agregar-editar-tags",
              hide:
                access?.CRUD_usuario_dios ||
                  access?.CRUD_usuario_editorial ||
                  access?.CRUD_usuario_vendedor
                  ? false
                  : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <BrushOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.libros.eliminar && (
        <NavigationCollapse
          categorieID={"Libros_Eliminar"}
          categorieLabel={"Eliminar elementos"}
          currentCategorie={currentCategorie.Libros_Eliminar}
          categorieItems={[
            {
              name: "Eliminar un libro",
              url: "/registrar-y-editar/eliminar-libro",
              hide: access?.eliminar_libro_contenido ? false : true,
            },
            {
              name: "Eliminar un paquete de libros",
              url: "/registrar-y-editar/eliminar-paquete-libros",
              hide: access?.eliminar_paquete_libros ? false : true,
            },
            {
              name: "Eliminar una colección",
              url: "/registrar-y-editar/eliminar-coleccion",
              hide: access?.eliminar_coleccion ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <DeleteOutlineIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {/* =================== ACTIVIDADES =================== */}
      {ver.actividades.value && <SectionHeader label="Actividades" />}

      {ver.actividades.ver_datos && (
        <NavigationCollapse
          categorieID={"Actividades_VerDatos"}
          categorieLabel={"Ver datos"}
          currentCategorie={currentCategorie.Actividades_VerDatos}
          categorieItems={[
            {
              name: "Lista de actividades",
              url: "/consultas/lista-actividades",
              hide: access?.ver_actividades ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <ExtensionOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.actividades.adicionar && (
        <NavigationCollapse
          categorieID={"Actividades_Adicionar"}
          categorieLabel={"Adicionar"}
          currentCategorie={currentCategorie.Actividades_Adicionar}
          categorieItems={[
            {
              name: "Agregar una actividad",
              url: "/registrar-y-editar/agregar-nueva-actividad",
              hide: access?.crear_actividad ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <AddCircleOutlineOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.actividades.editar && (
        <NavigationCollapse
          categorieID={"Actividades_Editar"}
          categorieLabel={"Editar"}
          currentCategorie={currentCategorie.Actividades_Editar}
          categorieItems={[
            {
              name: "Editar una actividad",
              url: "/registrar-y-editar/editar-actividad",
              hide: access?.editar_actividad ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <EditOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.actividades.eliminar && (
        <NavigationCollapse
          categorieID={"Actividades_Eliminar"}
          categorieLabel={"Eliminar"}
          currentCategorie={currentCategorie.Actividades_Eliminar}
          categorieItems={[
            {
              name: "Eliminar una actividad",
              url: "/registrar-y-editar/eliminar-actividad",
              hide: access?.eliminar_actividad ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <DeleteOutlineIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {/* =================== EVENTOS =================== */}
      {ver.eventos.value && <SectionHeader label="Eventos" />}

      {ver.eventos.eventos && (
        <NavigationCollapse
          categorieID={"Eventos_Eventos"}
          categorieLabel={"Eventos"}
          currentCategorie={currentCategorie.Eventos_Eventos}
          categorieItems={[
            {
              name: "Lista de eventos",
              url: "/consultas/lista-eventos",
              hide: access?.ver_codigos_regalo ? false : true,
              // TODO: cambiar por el access de eventos cuando sea creado
            },
            {
              name: "Crear evento",
              url: "/registrar-y-editar/crear-evento",
              hide: access?.ver_regalias ? false : true,
              // TODO: cambiar por el access de eventos cuando sea creado
            },
            {
              name: "Editar evento",
              url: "/registrar-y-editar/editar-evento",
              // TODO: Poner el hide cuando se creen los permisos de acceso para eventos
            },
            {
              name: "Eliminar evento",
              url: "/registrar-y-editar/eliminar-evento",
              hide: access?.eliminar_cliente_instituto ? false : true,
              // TODO: cambiar por el access de eventos cuando sea creado
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <EventOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.eventos.formularios && (
        <NavigationCollapse
          categorieID={"Eventos_Formularios"}
          categorieLabel={"Formularios"}
          currentCategorie={currentCategorie.Eventos_Formularios}
          categorieItems={toCategorieItems(RoutesFormularios)}
          changeCategorie={changeCategorie}
        >
          <AssignmentOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {/* =================== BLOG =================== */}
      {ver.blog.value && <SectionHeader label="Blog" />}

      {ver.blog.manejo_blog && (
        <NavigationCollapse
          categorieID={"Blog_ManejoBlog"}
          categorieLabel={"Manejo del blog"}
          currentCategorie={currentCategorie.Blog_ManejoBlog}
          categorieItems={[
            {
              name: "Crear nueva entrada del blog",
              url: "/blog/crear-entrada-blog",
              hide: access?.crear_entrada_blog ? false : true,
            },
            {
              name: "Editar entrada del blog",
              url: "/blog/editar-entrada-blog",
              hide: access?.editar_entrada_blog ? false : true,
            },
            {
              name: "Eliminar entrada del blog",
              url: "/blog/eliminar-entrada-blog",
              hide: access?.eliminar_entrada_blog ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <ForumOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {/* =================== GESTIÓN DE PLATAFORMA =================== */}
      {ver.plataforma.value && <SectionHeader label="Gestión de plataforma" />}

      {ver.plataforma.banners && (
        <NavigationCollapse
          categorieID={"Plataforma_Banners"}
          categorieLabel={"Banners"}
          currentCategorie={currentCategorie.Plataforma_Banners}
          categorieItems={[
            {
              name: "Gestión de banners",
              url: "/home-y-otros/cambiar-los-banners",
              hide: access?.editar_banners ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <ImageOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plataforma.filas && (
        <NavigationCollapse
          categorieID={"Plataforma_Filas"}
          categorieLabel={"Filas del home"}
          currentCategorie={currentCategorie.Plataforma_Filas}
          categorieItems={[
            {
              name: "Gestión de filas",
              url: "/registrar-y-editar/filas-home",
              hide: access?.crear_cliente_instituto ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <ViewAgendaOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plataforma.recursos && (
        <NavigationCollapse
          categorieID={"Plataforma_Recursos"}
          categorieLabel={"Recursos"}
          currentCategorie={currentCategorie.Plataforma_Recursos}
          categorieItems={[
            {
              name: "Lista de recursos",
              url: "/consultas/lista-recursos",
              hide: access?.ver_codigos_regalo ? false : true,
              // TODO: cambiar por el access de recursos cuando sea creado
            },
            {
              name: "Crear recurso",
              url: "/registrar-y-editar/crear-recurso",
              hide: access?.crear_cliente_instituto ? false : true,
              // TODO: cambiar por el access de recursos cuando sea creado
            },
            {
              name: "Editar recurso",
              url: "/registrar-y-editar/editar-recurso",
              // TODO: Poner el hide cuando se creen los permisos de acceso para recursos
            },
            {
              name: "Eliminar recurso",
              url: "/registrar-y-editar/eliminar-recurso",
              hide: access?.eliminar_cliente_instituto ? false : true,
              // TODO: cambiar por el access de recursos cuando sea creado
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <LibraryBooksOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plataforma.notibuzon && (
        <NavigationCollapse
          categorieID={"Plataforma_Notibuzon"}
          categorieLabel={"Notibuzón"}
          currentCategorie={currentCategorie.Plataforma_Notibuzon}
          categorieItems={[
            {
              name: "Lista de notibuzón",
              url: "/consultas/lista-notibuzon",
              hide: access?.ver_codigos_regalo ? false : true,
              // TODO: cambiar por el access de NOTIBUZON cuando sea creado
            },
            {
              name: "Crear notibuzón",
              url: "/registrar-y-editar/crear-notibuzon",
              hide: access?.crear_cliente_instituto ? false : true,
              // TODO: cambiar por el access de NOTIBUZON cuando sea creado
            },
            {
              name: "Editar notibuzón",
              url: "/registrar-y-editar/editar-notibuzon",
              // TODO: cambiar por el access de NOTIBUZON cuando sea creado
            },
            {
              name: "Eliminar notibuzón",
              url: "/registrar-y-editar/eliminar-notibuzon",
              hide: access?.eliminar_cliente_instituto ? false : true,
              // TODO: cambiar por el access de NOTIBUZON cuando sea creado
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <NotificationsNoneOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plataforma.notibanner && (
        <NavigationCollapse
          categorieID={"Plataforma_Notibanner"}
          categorieLabel={"Notibanner"}
          currentCategorie={currentCategorie.Plataforma_Notibanner}
          categorieItems={[
            {
              name: "Lista de notibanner",
              url: "/consultas/lista-notibanner",
              hide: access?.ver_codigos_regalo ? false : true,
              // TODO: cambiar por el access de NOTIBANNER cuando sea creado
            },
            {
              name: "Crear notibanner",
              url: "/registrar-y-editar/crear-notibanner",
              hide: access?.crear_cliente_instituto ? false : true,
              // TODO: cambiar por el access de NOTIBANNER cuando sea creado
            },
            {
              name: "Editar notibanner",
              url: "/registrar-y-editar/editar-notibanner",
              // TODO: cambiar por el access de NOTIBANNER cuando sea creado
            },
            {
              name: "Eliminar notibanner",
              url: "/registrar-y-editar/eliminar-notibanner",
              hide: access?.eliminar_cliente_instituto ? false : true,
              // TODO: cambiar por el access de NOTIBANNER cuando sea creado
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <ViewCarouselOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plataforma.usuarios && (
        <NavigationCollapse
          categorieID={"Plataforma_Usuarios"}
          categorieLabel={"Usuarios"}
          currentCategorie={currentCategorie.Plataforma_Usuarios}
          categorieItems={[
            {
              name: "Agregar un nuevo usuario administrativo",
              url: "/registrar-y-editar/agregar-cliente-administrativo",
              hide:
                client?.access?.CRUD_usuario_dios ||
                  client?.access?.CRUD_usuario_editorial ||
                  client?.access?.CRUD_usuario_vendedor
                  ? false
                  : true,
            },
            {
              name: "Editar un usuario administrativo",
              url: "/registrar-y-editar/editar-usuario-admin",
              hide:
                access?.CRUD_usuario_dios ||
                  access?.CRUD_usuario_editorial ||
                  access?.CRUD_usuario_vendedor
                  ? false
                  : true,
            },
            {
              name: "Eliminar un usuario administrativo",
              url: "/registrar-y-editar/eliminar-usuario-admin",
              hide:
                access?.CRUD_usuario_dios ||
                  access?.CRUD_usuario_editorial ||
                  access?.CRUD_usuario_vendedor
                  ? false
                  : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <GroupOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {/* =================== PLAN LECTOR (sin cambios) =================== */}
      {ver.plan_lector.value && <SectionHeader label="Plan Lector" />}

      {ver.plan_lector.ver_datos && (
        <NavigationCollapse
          categorieID={"PlanLector_VerDatos"}
          categorieLabel={"Ver datos"}
          currentCategorie={currentCategorie.PlanLector_VerDatos}
          categorieItems={[
            {
              name: "Lista de Institutos plan lector",
              url: "/plan-lector/lista-institutos",
              hide: access?.ver_institutos_PL ? false : true,
            },
            {
              name: "Lista de Sedes plan lector",
              url: "/plan-lector/lista-sedes",
              hide: access?.ver_sedes ? false : true,
            },
            {
              name: "Lista de Cursos plan lector",
              url: "/plan-lector/lista-cursos",
              hide: access?.ver_cursos ? false : true,
            },
            {
              name: "Lista de profesores plan lector",
              url: "/plan-lector/lista-profesores",
              hide: access?.ver_profesores ? false : true,
            },
            {
              name: "Lista de estudiantes plan lector",
              url: "/plan-lector/lista-estudiantes",
              hide: access?.ver_estudiantes ? false : true,
            },
            {
              name: "Reporte Lecturas",
              url: "/plan-lector/reporte-lecturas-pl",
              hide: access?.reporte_lecturas ? false : true,
            },
            {
              name: "Reporte accesos estudiantes",
              url: "/plan-lector/reporte-acceso-estudiantes",
              hide: access?.reporte_acceso_estudiantes ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <VisibilityOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plan_lector.ver_estadisticas && (
        <NavigationCollapse
          categorieID={"PlanLector_VerEstadisticas"}
          categorieLabel={"Ver estadísticas"}
          currentCategorie={currentCategorie.PlanLector_VerEstadisticas}
          categorieItems={[
            {
              name: "Estadísticas globales de lectura y acceso",
              url: "/plan-lector/estadisticas-generales",
              hide: access?.reporte_lecturas ? false : true,
            },
            {
              name: "Estadísticas de acceso especificas",
              url: "/plan-lector/estadisticas-acceso",
              hide: access?.reporte_acceso_estudiantes ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <TimelineOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plan_lector.adicionar_elementos && (
        <NavigationCollapse
          categorieID={"PlanLector_AdicionarElementos"}
          categorieLabel={"Adicionar Elementos"}
          currentCategorie={currentCategorie.PlanLector_AdicionarElementos}
          categorieItems={[
            {
              name: "Agregar un nuevo instituto plan lector",
              url: "/plan-lector/agregar-nuevo-instituto",
              hide: access?.agregar_instituto_PL ? false : true,
            },
            {
              name: "Agregar una nueva sede plan lector",
              url: "/plan-lector/agregar-nueva-sede",
              hide: access?.agregar_sede ? false : true,
            },
            {
              name: "Agregar un nuevo curso plan lector",
              url: "/plan-lector/agregar-nuevo-curso",
              hide: access?.agregar_curso ? false : true,
            },
            {
              name: "Agregar un nuevo estudiante plan lector",
              url: "/plan-lector/agregar-nuevo-estudiante",
              hide: access?.agregar_estudiante ? false : true,
            },
            {
              name: "Agregar un nuevo profesor",
              url: "/plan-lector/agregar-nuevo-profesor",
              hide: access?.agregar_profesor ? false : true,
            },
            {
              name: "Asignar cursos a profesores plan lector",
              url: "/plan-lector/asignar-cursos",
              hide: access?.agregar_curso ? false : true,
            },
            {
              name: "Agregar o eliminar libros de un paquete",
              url: "/registrar-y-editar/agregar-eliminar-libros-paquete",
              hide: access?.agregar_libro_paquete ? false : true,
            },
            {
              name: "Habilitar paquete personalizado",
              url: "/plan-lector/habilitar-paquete-pl",
              hide: access?.habilitar_paquete_PL ? false : true,
            },
            {
              name: "Autorizar paquete personalizado para instituto",
              url: "/plan-lector/autorizar-paquete-pl",
              hide: access?.autorizar_paquete_PL ? false : true,
            },
            {
              name: "Agregar o eliminar un paquete a un instituto",
              url: "/plan-lector/agregar-eliminar-paquete-instituto-pl",
              hide: access?.agregar_instituto_PL ? false : true,
            },
            {
              name: "Agregar o eliminar un paquete a una sede",
              url: "/plan-lector/agregar-eliminar-paquete-sede-pl",
              hide: access?.agregar_sede ? false : true,
            },
            {
              name: "Agregar o eliminar libros a un curso",
              url: "/plan-lector/agregar-eliminar-libros-curso",
              hide: access?.agregar_curso ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <AddCircleOutlineOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plan_lector.editar_elementos && (
        <NavigationCollapse
          categorieID={"PlanLector_EditarElementos"}
          categorieLabel={"Editar Elementos"}
          currentCategorie={currentCategorie.PlanLector_EditarElementos}
          categorieItems={[
            {
              name: "Editar un instituto plan lector",
              url: "/plan-lector/editar-un-instituto",
              hide: access?.editar_instituto_PL ? false : true,
            },
            {
              name: "Editar una sede plan lector",
              url: "/plan-lector/editar-una-sede",
              hide: access?.editar_sede ? false : true,
            },
            {
              name: "Editar un curso plan lector",
              url: "/plan-lector/editar-un-curso",
              hide: access?.editar_curso ? false : true,
            },
            {
              name: "Editar un estudiante plan lector",
              url: "/plan-lector/editar-un-estudiante",
              hide: access?.editar_estudiante ? false : true,
            },
            {
              name: "Editar un profesor plan lector",
              url: "/plan-lector/editar-un-profesor",
              hide: access?.editar_profesor ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <EditOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.plan_lector.borrar_elementos && (
        <NavigationCollapse
          categorieID={"PlanLector_BorrarElementos"}
          categorieLabel={"Borrar Elementos"}
          currentCategorie={currentCategorie.PlanLector_BorrarElementos}
          categorieItems={[
            {
              name: "Eliminar un estudiante",
              url: "/plan-lector/eliminar-un-estudiante",
              hide: access?.eliminar_estudiante ? false : true,
            },
            {
              name: "Eliminar un profesor",
              url: "/plan-lector/eliminar-un-profesor",
              hide: access?.eliminar_profesor ? false : true,
            },
            {
              name: "Eliminar un curso",
              url: "/plan-lector/eliminar-un-curso",
              hide: access?.eliminar_curso ? false : true,
            },
            {
              name: "Eliminar un instituto",
              url: "/plan-lector/eliminar-un-instituto",
              hide: access?.eliminar_instituto_PL ? false : true,
            },
            {
              name: "Eliminar una sede",
              url: "/plan-lector/eliminar-una-sede",
              hide: access?.eliminar_sede ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <DeleteOutlineIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {/* =================== FORMACIÓN (sin cambios) =================== */}
      {ver.formacion.value && <SectionHeader label="Formación" />}

      {ver.formacion.ver_datos && (
        <NavigationCollapse
          categorieID={"Formacion_VerDatos"}
          categorieLabel={"Ver Datos"}
          currentCategorie={currentCategorie.Formacion_VerDatos}
          categorieItems={[
            {
              name: "Lista de usuarios Academia",
              url: "/formacion/lista-usuarios-academia",
            },
            {
              name: "Lista de Cursos Academia",
              url: "/formacion/lista-cursos-academia",
            },
            {
              name: "Reporte Usuarios Academia",
              url: "/formacion/reporte-usuarios-academia",
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <VisibilityOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.formacion.adicionar_elementos && (
        <NavigationCollapse
          categorieID={"Formacion_AdicionarElementos"}
          categorieLabel={"Adicionar Elementos"}
          currentCategorie={currentCategorie.Formacion_AdicionarElementos}
          categorieItems={[
            {
              name: "Crear un usuario Academia",
              url: "/formacion/crear-usuario-academia",
            },
            {
              name: "Asignar un curso a un usuario",
              url: "/formacion/asignar-curso-usuario",
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <AddCircleOutlineOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.formacion.adicionar_elementos && (
        <NavigationCollapse
          categorieID={"Formacion_EditarElementos"}
          categorieLabel={"Editar Elementos"}
          currentCategorie={currentCategorie.Formacion_EditarElementos}
          categorieItems={[...toCategorieItems(RoutesUsuariosAcademia)]}
          changeCategorie={changeCategorie}
        >
          <EditOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.formacion.borrar_elementos && (
        <NavigationCollapse
          categorieID={"Formacion_BorrarElementos"}
          categorieLabel={"Borrar Elementos"}
          currentCategorie={currentCategorie.Formacion_BorrarElementos}
          categorieItems={[
            {
              name: "Borrar un usuario Academia",
              url: "/formacion/borrar-usuario-academia",
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <DeleteOutlineIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {/* =================== NUEVAS REGALÍAS (sin cambios) =================== */}
      {ver.regalias.value && <SectionHeader label="Nuevas Regalías" />}

      {ver.regalias.ver_datos && (
        <NavigationCollapse
          categorieID={"NuevasRegalias_VerDatos"}
          categorieLabel={"Ver Datos"}
          currentCategorie={currentCategorie.NuevasRegalias_VerDatos}
          categorieItems={[
            {
              name: "Lista de cortes de regalía",
              url: "/nuevas-regalias/lista-cortes-regalia",
              hide: access?.ver_regalias ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <VisibilityOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}

      {ver.regalias.adicionar_elementos && (
        <NavigationCollapse
          categorieID={"NuevasRegalias_AdicionarElementos"}
          categorieLabel={"Adicionar Elementos"}
          currentCategorie={currentCategorie.NuevasRegalias_AdicionarElementos}
          categorieItems={[
            {
              name: "Crear un nuevo corte regalías por cliente",
              url: "/nuevas-regalias/crear-nuevo-corte",
              hide: access?.crear_regalias ? false : true,
            },
          ]}
          changeCategorie={changeCategorie}
        >
          <AddCircleOutlineOutlinedIcon style={iconStyle} />
        </NavigationCollapse>
      )}
    </>
  );
};

export default NavigationElements;
